// extracted by mini-css-extract-plugin
export default {"legendHeader":"Memory_legendHeader__GB+tA","bold":"Memory_bold__+pqlx"};